module.exports = __webpack_public_path__ + "img/9.dc470e89.png";